<template>
<div class="main-in">
    <div class="container" v-cloak>
        <div is='titlebox' :nav='JSON.parse(nav)' ></div>
        <div class="content">
            <!-- <div class="left-corner f-row-l">
                <div class="bg-title1 f-row-c bbact">{{title}}</div>
            </div> -->
            <div class="words min-h" v-if='this.type!=12&&this.type!=13'>
                <strong v-if='info.title'>{{info.title}}</strong>
                <ul>
                    <li v-if='info.source'>来源：{{info.source}}</li>
                    <li v-if='info.author'>作者：{{info.author}}</li>
                    <li v-if='info.createTime'>发布时间：{{info.createTime}}</li>
                </ul>
                <div class="words2 pt-4">
                    <div v-html="$util.regImg(info.content)" v-if='info.content'></div>
                    <div v-html="$util.regImg(info.hypertext)"  v-if='info.hypertext'></div>
                </div>
            </div>
            <div v-else class="min-h">
                <strong v-if='info.title'>{{info.memberName}}</strong>
                <div class="words2 pt-4">
                    <div class="f-row-c">
                        <img class="headbox" v-if='info.memberImg' :src='$imgUrl+info.memberImg'/>
                    </div>
                    <div class="f-row-c mt-1 title">{{info.memberName}}</div>
                    <div class="" v-if='info.memberIntroduce'>
                        <div v-html="$util.regImg(info.memberIntroduce)"></div>
                    </div>

                </div>
            </div>
            <!-- {{JSON.stringify(info)}} -->
            <div v-if='info.file' class="downbox">
                <div v-if='type!=32'>
                    <span class="downicon pinter" v-for='(item,ind) in info.file.split(",")' :key='ind' :title="item" @click="openUrl($imgUrl+item)">
                    附件下载
                    </span>
                </div>

            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    computed:{
        nav:function(){
            var tier=3;

            if(this.type == '0'){
                this.title = '热点新闻';
            }else{
                this.$axios.get(this.$apiUrlZY+'api/infocolumn/volInfoColumn/rootList').then(res=>{
                    if(res.success){
                        let newsTypeList=res.result;
                        for(var i= 0 ;i < newsTypeList.length;i++){
                            if(this.type == (i+1)){
                                this.title = newsTypeList[i].name;
                            }
                        }
                    }
                })
            }

            var arr=this.$util.getTopNavZyz(this.title, this.$route.query.type,tier)
            return JSON.stringify(arr)
        },
    },
    data() {
        return {
            title:'热点新闻',
            type:this.$route.query.type || '0',
            id:this.$route.query.id,
            msgType:'',
            info:{},
            fileList:[]
        };
    },
    created(){
        this.getZYinfo(this.id)

    },
    methods:{
        getZYinfo(id){//志愿者接口
            this.$axios.get(this.$apiUrlZY+`api/external/queryRootById?id=${id}`).then(res=>{
                this.info=res.result
            })
        },
    },
    mounted(){

    },
}
</script>
<style lang="scss" scoped>
.content {
    position: relative;
    background-color: #fff;
    padding: 0px 50px;
    min-height: 480px;
    .left-corner {
        line-height: 5px;
        border-bottom: #d6dde6 1px solid;
    }

    .words{
        font-size: 16px;
        line-height: 38px;
        text-align: center;
        font-family: Microsoft YaHei;
        margin-top: 42px;
        padding-bottom: 200px;
        strong{
            width: 100%;
            font-size: 28px;
            color: #333333;
            line-height: 40px;
            font-weight: 400;
        }
        ul{
            width:  100%;
            text-align: center;
            margin-left: -15px;
             li{
                list-style: none;
                display: inline;
                font-weight: 400;
                color: #666666;
                font-family: Microsoft YaHei;
                padding: 20px;
            }
        }
        .words2{
            width: 100%;
            text-align: left;
            font-weight: 400;
            font-family: Microsoft YaHei;
            color: #333333;
            line-height: 38px;
            padding:0px 10px 10px;
        }
    }
}
.headbox{
    width: 200px;
}
.title{
    font-size: 28px;
    padding-bottom: 20px;
}
.downbox{
    margin: 30px 50px 50px;
    font-size: 16px;
    color: #E61F26;
    .downicon{
    position: relative;
    display: inline-block;
    padding-left: 22px;
    padding-bottom: 20px;
    margin-right: 30px;
  }
  .downicon::before{
    content: '';
    width: 18px;
    height: 20px;
    position: absolute;
    left: 0px;
    background: url('../../assets/img/index/tuanzhang.png') no-repeat center/100% auto;
  }
}
</style>
